export default __webpack_public_path__ + "static/national-yards-mobile-60528e22590d504bdb024d03a8439a79.svg";